// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"spinner_ko-KR__OvvGJ","impressionTrackingContainer":"spinner_impressionTrackingContainer__cLnvb","spinner":"spinner_spinner__vp_wB","rotate":"spinner_rotate__CWK09"};